import { useState } from 'react';
import { DateRangeFilterState } from '../state';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { Filter, RangeItem } from '@wix/bex-core';
import { useFilterToolbarState } from '../providers';

export interface UseDateRangeFilterStateParams {
  filter: Filter<RangeItem<Date>>;
  filterByTime?: boolean;
}

export function useDateRangeFilterState(params: UseDateRangeFilterStateParams) {
  const { filter, filterByTime } = params;

  const { translate } = useWixPatternsContainer();
  const toolbar = useFilterToolbarState();

  const [state] = useState(
    () =>
      new DateRangeFilterState({
        translate,
        filter,
        toolbar,
        filterByTime,
      }),
  );

  return state;
}
